import { useEffect, useState } from "react";
import { Button, Paper, Stack, Table, TableBody, TableCell, TableHead, TablePagination, TableRow } from "@mui/material";
import CardModal from "../components/CardModal";
import { deleteCard, listCardsPaged } from "../api/cards";
import { EmptyState, PageHeader } from "../components/ui";

function getSupplierCode(row) {
  return row?.code || row?.customer_code || "";
}

function currentUserRole() {
  try {
    return JSON.parse(localStorage.getItem("user") || "null")?.role || null;
  } catch {
    return null;
  }
}

function Suppliers() {
  // Tedarikçi eklemek depocu rolüne özel; admin de ekleyebilir.
  const role = currentUserRole();
  const canAdd = role === "depocu" || role === "admin";
  const canEditDelete = role === "admin";
  const [list, setList] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [selected, setSelected] = useState(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [total, setTotal] = useState(0);

  function reload() {
    listCardsPaged({ type: "supplier", page: page + 1, limit: rowsPerPage }).then((data) => {
      setList(data?.items || []);
      setTotal(Number(data?.total || 0));
    });
  }

  useEffect(() => {
    reload();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, rowsPerPage]);

  function remove(id) {
    if (!window.confirm("Silmek istiyor musun?")) return;

    deleteCard(id).then(() => {
      reload();
    });
  }

  return (
    <Stack spacing={2}>
      <PageHeader
        title="Tedarikçiler"
        subtitle="Tedarikçi kartlarını yönetin."
        actions={
          <Button
            variant="contained"
            disabled={!canAdd}
            title={!canAdd ? "Tedarikçi eklemek sadece depocu rolüne özeldir." : undefined}
            onClick={() => {
              setSelected(null);
              setModalOpen(true);
            }}
          >
            + Yeni Tedarikçi
          </Button>
        }
      />

      {!list.length ? (
        <EmptyState
          description="Henüz tedarikçi kartı yok."
          actionLabel="+ Yeni Tedarikçi"
          onAction={canAdd ? () => setModalOpen(true) : undefined}
        />
      ) : (
        <Paper>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Ad</TableCell>
                <TableCell>Tedarikçi Kodu</TableCell>
                <TableCell>Telefon</TableCell>
                <TableCell>Adres / Şehir</TableCell>
                <TableCell align="right">İşlemler</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {list.map((x) => (
                <TableRow key={x.id} hover>
                  <TableCell>{x.name}</TableCell>
                  <TableCell>{getSupplierCode(x)}</TableCell>
                  <TableCell>{x.phone || ""}</TableCell>
                  <TableCell>{x.address || ""}</TableCell>
                  <TableCell align="right">
                    <Stack direction="row" spacing={1} justifyContent="flex-end">
                      <Button
                        size="small"
                        variant="outlined"
                        disabled={!canEditDelete}
                        title={!canEditDelete ? "Tedarikçi düzenlemek sadece admin rolüne özeldir." : undefined}
                        onClick={() => {
                          setSelected(x);
                          setModalOpen(true);
                        }}
                      >
                        Düzenle
                      </Button>
                      <Button
                        size="small"
                        color="error"
                        variant="outlined"
                        disabled={!canEditDelete}
                        title={!canEditDelete ? "Tedarikçi silmek sadece admin rolüne özeldir." : undefined}
                        onClick={() => remove(x.id)}
                      >
                        Sil
                      </Button>
                    </Stack>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
          <TablePagination
            component="div"
            count={total}
            page={page}
            onPageChange={(_, newPage) => setPage(newPage)}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={(e) => {
              setRowsPerPage(Number(e.target.value));
              setPage(0);
            }}
            rowsPerPageOptions={[10, 25, 50, 100]}
            labelRowsPerPage="Sayfa başına kayıt"
          />
        </Paper>
      )}

      {modalOpen ? (
        <CardModal
          type="supplier"
          data={selected}
          onClose={() => setModalOpen(false)}
          onSaved={() => reload()}
        />
      ) : null}

    </Stack>
  );
}

export default Suppliers;
